module.exports = __webpack_public_path__ + "static/media/huobi.e1b77909.svg";